import {TopToolbar, EditButton, ListButton} from 'ra-ui-materialui'
import React from 'react'

export default ({basePath, data}) => (
  <TopToolbar>
    <ListButton basePath={basePath}/>
    <EditButton basePath={basePath} record={data}/>
  </TopToolbar>
)
